import { Brick, registerBrick } from 'olympe';

export default class AddMultiFilterForValidateVendorId extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {ListDef} records
     * @param {string} body
     * @param {function()} forwardEvent
     * @param {function(string)} setBody
     */
    update($, [body], [forwardEvent, setBody]) {
        // Parse the bosy into a JSON object
        let query = JSON.parse(body);
        // Initialize the filters array
        const filters = [];
          filters.push({
            field: 'vendorGroup',
            value: "Z007",
            operator: '=',
            group: 0,
          });
          filters.push({
            field: 'vendorGroup',
            value: "Z009",
            operator: '=',
            group: 0,
          });
        // });
    
        // Add filters to the query object
        query.filters = filters;
        // Output the result
        const output = JSON.stringify(query);
        setBody(output);
        forwardEvent();
      }
    }

registerBrick('0196f30dd8a1b7084749', AddMultiFilterForValidateVendorId);
